export default "__VITE_ASSET__guCYncTT__"